import React from 'react';

import CertificationLayout from '../../src/components/layouts/certification';
import DefaultLayout from '../../src/components/layouts/default';
import FourOhFourPage from '../../src/pages/404';
import FloatButton from '../../src/components/ui/FloatButton';
import MainAdminLayout from '../../src/components/layouts/admin';

interface LayoutSelectorProps {
  element: JSX.Element;
  props: {
    location: { pathname: string };
    pageContext?: { challengeMeta?: { block?: string; superBlock?: string } };
  };
}
export default function layoutSelector({
  element,
  props
}: LayoutSelectorProps): JSX.Element {
  const {
    location: { pathname }
  } = props;

  const isChallenge = !!props.pageContext?.challengeMeta;

  if (element.type === FourOhFourPage) {
    return (
      <DefaultLayout pathname={pathname} showFooter={true}>
        <FloatButton />
        {element}
      </DefaultLayout>
    );
  } else if (/\/certification\//.test(pathname)) {
    return (
      <CertificationLayout pathname={pathname}>{element}</CertificationLayout>
    );
  } else if (/^\/admin/.test(pathname)) {
    return <MainAdminLayout pathname={pathname}>{element}</MainAdminLayout>;
  } else if (/^\/cadastro-sctec/.test(pathname)) {
    // Página exclusiva do SCTEC: traz header/footer próprios e não deve
    // expor a navegação padrão da plataforma [RN02 do doc SCTEC]
    return element;
  } else if (isChallenge) {
    return (
      <DefaultLayout
        pathname={pathname}
        showFooter={false}
        isChallenge={true}
        block={props.pageContext?.challengeMeta?.block}
        superBlock={props.pageContext?.challengeMeta?.superBlock}
      >
        {element}
      </DefaultLayout>
    );
  } else {
    return (
      <DefaultLayout pathname={pathname} showFooter={true}>
        <FloatButton />
        {element}
      </DefaultLayout>
    );
  }
}
